import { isUndefined } from 'lodash';

export const getStringAccountId = accountId => (isUndefined(accountId) ? '' : `${accountId}`);
